import { faTwitter, faLinkedinIn, faFacebookF, faYoutube, faInstagram, faWhatsapp, faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import client from '../../utils/prismicHelpers';
import * as queries from "../../utils/prismicQueries";
import twitter from '../../assets/images/social-logo/akar-icons_twitter-fill (1).png'
import youtube from '../../assets/images/social-logo/akar-icons_youtube-fill (1).png'
import facebook from '../../assets/images/social-logo/ant-design_facebook-filled (1).png'
import instagram from '../../assets/images/social-logo/bx_bxl-instagram-alt (1).png'
import linkedin from '../../assets/images/social-logo/bx_bxl-linkedin (1).png'
import twitter_hover from '../../assets/images/social-logo-hover/akar-icons_twitter-fill.png'
import youtube_hover from '../../assets/images/social-logo-hover/akar-icons_youtube-fill.png'
import facebook_hover from '../../assets/images/social-logo-hover/ant-design_facebook-filled.png'
import instagram_hover from '../../assets/images/social-logo-hover/bx_bxl-instagram-alt.png'
import linkedin_hover from '../../assets/images/social-logo-hover/bx_bxl-linkedin.png'

const SocialLinks = ({ showWhatsApp }) => {

    const [social, setSocial] = useState(null);


    useEffect(() => {
        client
            .query({
                query: queries.contact,
            })
            .then((response) => {
                const socialLinks = response.data.allContacts.edges[0].node;
                setSocial(socialLinks);


            })
            .catch((error) => {
                console.error(error);
            });
    });
    const socialLinksSTyle = `
    .links-container a{
        filter: grayscale(100%);
    }
    .links-container a:hover{
        filter: grayscale(0%);
    }
    `
    return (
        <>
            <style>{socialLinksSTyle}</style>
            <div className=" d-flex links-container justify-content-between ">
                {/* {social?.social_links?.map((link, index) => {

                    <a
                        key={index}
                        href={link.link}
                        target="_blank"
                        rel="noopener noreferrer"

                    >
                        <img
                            src={link.icon.url}
                            alt=""
                            className="img-fluid"
                        />
                    </a>

                })
                } */}
                <a target="_blank" href={social?.socilal[0].twitter[0]?.text}>  <img src={twitter_hover} alt="" /></a>
                <a target="_blank" href={social?.socilal[0].instragram[0]?.text}>  <img src={linkedin_hover} alt="" /></a>
                <a target="_blank" href={social?.socilal[0].fb[0]?.text}>   <img src={facebook_hover} alt="" /></a>
                <a target="_blank" href={social?.socilal[0].linkedin[0]?.text}>  <img src={youtube_hover} alt="" /></a>
                <a target="_blank" href={social?.socilal[0].youtube[0]?.text}>   <img src={instagram_hover} alt="" /></a>
                {showWhatsApp && <a href="https://web.whatsapp.com/send?text=https://art-park-b4155.web.app" target="_blank">  <FontAwesomeIcon icon={faWhatsapp} /></a>}
            </div>
        </>
    );
};

export default SocialLinks;